

let initialState = {
    userComments:[]
}

function userComments(state = initialState, action) {
        if (action.type === "USERCOMMENT_ADD") {
            return {
                ...state,
                userComments: state.userComments.concat( action.userComment )
            }
    
    
        } else if (action.type === "USERCOMMENT_REMOVE"){
            return {
                ...state,
                userComments: state.userComments.filter(userComment => userComment.id !== action.id)
            }
        } else if (action.type === "USERCOMMENT_REMOVE_ALL"){
            return {
                ...state,
                userComments: []
            }
        } else if (action.type === "USERCOMMENT_UPDATE"){
        
            const index = state.userComments.findIndex(i => i.id === action.userComment.id)
            return {
                ...state,
                userComments:[...state.userComments.slice(0,index), 
                    action.userComment,
                    ...state.userComments.slice(1+index)]
    
            }
        }
    
        return state;
}

export default userComments;